module.exports = __webpack_public_path__ + "img/header.b5a8289a.png";